import React from "react";

const Tematica = () => (
  <section className="campus-section">
    <div
    
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "4rem",
        alignItems: "center",
      }}
    >
      <div className="tema-content">
        <h3
          className="font-serif"
          style={{ fontSize: "3rem", marginBottom: "2rem" }}
        >
         Temática del encuentro
        </h3>

          <p
          style={{ color: "var(--gold)", fontSize: "1.7rem", marginBottom: "2rem", lineHeight:"1.3" }}
        > <b> Narrar el bien común:</b> el desafío comunicacional de las universidades
          católicas</p>
        <p
          style={{ color: "#d1d5db", fontSize: "1rem", marginBottom: "2rem", lineHeight:"1.3" }}
        >
          El VIII Encuentro de comunicadores de ODUCAL, invita a redescubrir la comunicación como una expresión
          viva de la misión universitaria. Desde el bien común como eje que
          orienta y da sentido, las universidades católicas están llamadas a
          trascender la información para construir narrativas que inspiren,
          conecten y hagan visible su impacto en la sociedad. En un entorno
          marcado por la transformación digital y la evolución de las
          audiencias, este desafío impulsa a integrar identidad, propósito y
          comunicación en una propuesta auténtica, capaz de generar confianza,
          fortalecer vínculos y proyectar, con claridad y coherencia, aquello
          que las distingue: su compromiso con la persona y la construcción de
          una sociedad más justa y solidaria.{" "}
        </p>
       
      </div>
    </div>
  </section>
);

export default Tematica;
